import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiAlertCircle, FiChevronRight, FiClock } from 'react-icons/fi';
import API from '../../utils/api';

const FeaturedServices = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await API.get('/api/service/featured', {
          params: { limit: 4 }
        });
        setServices(Array.isArray(response.data) ? response.data : []);
      } catch (err) {
        setError('Gagal memuat layanan unggulan');
        setServices([]);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  const formatPrice = (price) =>
    new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(price || 0);

  if (loading) {
    return (
      <section className="border-b border-slate-200 py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-t-2 border-primary" />
        </div>
      </section>
    );
  }

  return (
    <section className="border-b border-slate-200 py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr]">
          <div className="max-w-xl">
            <h2 className="mt-5 text-3xl font-bold text-slate-950 md:text-4xl">
              Layanan unggulan ditampilkan lebih tenang, tanpa kartu promosi yang menumpuk.
            </h2>
            <p className="mt-5 text-base leading-8 text-slate-600">
              Fokusnya ke nama layanan, estimasi waktu, dan harga. Cukup yang penting, tanpa dekorasi berlebih.
            </p>
            {error && (
              <div className="mt-6 inline-flex items-center text-sm font-medium text-orange-700">
                <FiAlertCircle className="mr-2" /> {error}
              </div>
            )}
          </div>

          <div className="border-t border-slate-200">
            {services.length === 0 ? (
              <div className="py-6 text-sm text-slate-500">Layanan unggulan belum tersedia saat ini.</div>
            ) : (
              services.map((service, index) => (
                <div
                  key={service.id}
                  className={`grid gap-4 py-6 md:grid-cols-[1fr_auto_auto] md:items-center ${
                    index !== services.length - 1 ? 'border-b border-slate-200' : ''
                  }`}
                >
                  <div>
                    <h3 className="text-lg font-semibold text-slate-950">{service.name}</h3>
                    <p className="mt-2 max-w-2xl text-sm leading-7 text-slate-600">{service.description}</p>
                  </div>
                  <div className="flex items-center text-sm text-slate-500">
                    <FiClock className="mr-2" />
                    {service.estimated_time} menit
                  </div>
                  <div className="text-sm font-semibold text-slate-900">{formatPrice(service.price)}</div>
                </div>
              ))
            )}

            <div className="pt-8">
              <Link to="/services" className="inline-flex items-center text-sm font-semibold text-primary hover:text-primary-dark">
                Buka semua layanan <FiChevronRight className="ml-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedServices;
